export const GIFT_FUND_ITEMS_COLLECTION = 'giftFundItems'
export const GIFT_FUND_STORAGE_PATH = 'giftFundItems'
